import { render, staticRenderFns } from "./OrderSubmission.vue?vue&type=template&id=31bb6e77&scoped=true&"
import script from "./OrderSubmission.vue?vue&type=script&lang=js&"
export * from "./OrderSubmission.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubmission.vue?vue&type=style&index=0&id=31bb6e77&scoped=true&lang=css&"
import style1 from "./OrderSubmission.vue?vue&type=style&index=1&id=31bb6e77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb6e77",
  null
  
)

export default component.exports